import { render } from "./WpeColor.vue?vue&type=template&id=8bbfd8be"
import script from "./WpeColor.vue?vue&type=script&lang=js"
export * from "./WpeColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeColor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8bbfd8be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8bbfd8be', __exports__)) {
    api.reload('8bbfd8be', __exports__)
  }
  
  module.hot.accept("./WpeColor.vue?vue&type=template&id=8bbfd8be", () => {
    api.rerender('8bbfd8be', render)
  })

}


export default __exports__